import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Route, Switch } from "react-router-dom";

import { LoadingDataState } from "altus-datastate";

import {
  RouteContainer,
  NoContentBasePage,
  ApplicationBaseContent,
} from "altus-ui-components";

import {
  getCurrentUserFromState,
  getActionDataStateFromState,
} from "app/app.selectors";

import routes from "app/routes";
import routePaths from "app/routePaths";
import { applicationOnLoad } from "app/app.actions";
import { filterValidRoutesForUser } from "utils/app.util";
import LoginContainer from "features/login/LoginContainer";
import ApplicationTabs from "app/components/ApplicationTabs";
import ApplicationHeader from "app/components/ApplicationHeader";
import { APP_ACTIONS } from "app/app.constants";

const NoAccessPage = () => (
  <NoContentBasePage
    header="Oops, we have nothing to show you..."
    description="Please try again later. If the problem persists,
please contact the HR Department or the Service Desk for
assistance."
  />
);

class ApplicationContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad } = this.props;

    dispatchOnLoad();
  }

  renderTopContent = () => {
    return (
      <>
        <ApplicationHeader />
        <ApplicationTabs />
      </>
    );
  };

  render() {
    const { currentUser, dataState } = this.props;

    const validRoutes = filterValidRoutesForUser(currentUser)(routes);

    return (
      <ApplicationBaseContent
        dataState={dataState}
        renderTopContent={this.renderTopContent}
      >
        <Switch>
          <Route exact path={routePaths.login} component={LoginContainer} />
          {!!validRoutes.length && (
            <Route render={() => <RouteContainer routes={validRoutes} />} />
          )}
          <Route component={NoAccessPage} />
        </Switch>
      </ApplicationBaseContent>
    );
  }
}

ApplicationContainer.defaultProps = {
  dataState: LoadingDataState,
};

export default compose(
  connect(
    state => ({
      currentUser: getCurrentUserFromState(state),
      dataState: getActionDataStateFromState(
        state,
        APP_ACTIONS.APPLICATION_ON_LOAD,
      ),
    }),
    {
      dispatchOnLoad: applicationOnLoad,
    },
  ),
)(ApplicationContainer);
